// src
import * as actions from "actions/events";
import { MINUTE } from "config/constants";
import { appGoesActive, hydrateSlice } from "actions/system";
import { backTokenSuccess } from "actions/user";
import { buildStorageAdapters } from "utils/storage";
import { cleanByPreset, filterByPresetToStore, updateByPreset } from "./updateCache";
import { updateEvents, updateRows } from "./updateDisplay";

const maxAge = 30 * MINUTE;
const saveDelay = 5000;
const whitelist = ["byPreset"];
const [hydrate, save] = buildStorageAdapters("events", {
  maxAge,
  saveDelay,
  whitelist,
});

const DEFAULT_STATE = {
  needsRefresh: true, // re-fetch events and presets
  byPreset: {}, // holds all events retrieved from server
  events: [], // for Calendar and Timeline components
  rows: [], // for Timeline component
};

export default (state = DEFAULT_STATE, { payload, type }) => {
  // order actions by frequency
  switch (type) {
    case actions.recompute.toString(): {
      const { enableds } = payload;
      // recomputes calendar events, timeline rows and title from byPreset
      // depending on enabled presets and displayed range
      return {
        ...state,
        events: updateEvents(state, enableds),
        rows: updateRows(enableds),
      };
    }
    case actions.eventsSuccess.toString(): {
      const { byPreset } = state;
      const cleanedByPreset = cleanByPreset(byPreset);
      const newByPreset = updateByPreset(cleanedByPreset, payload);
      const newState = {
        ...state,
        needsRefresh: false,
        byPreset: newByPreset,
      };
      return newState;
    }
    case actions.cacheEvents.toString(): {
      const { dateStart, dateEnd } = payload;
      const { byPreset } = state;
      const byPresetToStore = filterByPresetToStore(byPreset, dateStart, dateEnd);
      // save only a subpart
      save({
        byPreset: byPresetToStore,
      });
      return state;
    }
    case hydrateSlice.toString(): {
      return hydrate(state, payload);
    }
    case appGoesActive.toString(): {
      const idleDuration = payload;
      return {
        ...state,
        needsRefresh: idleDuration > actions.CACHE_DELAY,
      };
    }
    case actions.refresh.toString(): {
      return {
        ...state,
        needsRefresh: true,
      };
    }
    case backTokenSuccess.toString(): {
      return {
        ...state,
        needsRefresh: true,
      };
    }
    default:
      return state;
  }
};
